import { Component } from '@angular/core';

declare const setupSF: any; // Declare the setupSF function

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss']
})
export class SignUpComponent {
  constructor() { }

  ngOnInit() {
    this.loadScript('https://caklq-zc1.maillist-manage.in/js/optin.min.js');
    this.addSecondScript();
  }

  loadScript(url: string) {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    document.body.appendChild(script);
    script.onload = () => {
      setupSF('sf3z102605aabfae86df4ef525abfcf55101bc8ccf276ebda81df70e50a95d8f9387','ZCFORMVIEW',false,'acc',false,'2');
    };
  }

  addSecondScript(){
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.innerText=`function runOnFormSubmit_sf3z102605aabfae86df4ef525abfcf55101bc8ccf276ebda81df70e50a95d8f9387(th){};`
    document.body.appendChild(script);
  }
}
